var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 115,
    viewBox: "0 0 137 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.707 73.261l.054-.054c-1.939-.229-3.641.533-4.968 2.037l7.345 4.597c-1.252-3.928-2.414-6.542-2.431-6.58z",
    fill: "#57B894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.605 66.842l-37.827-4.718c-1.715-14.11.875-27.886 5.298-41.586l37.827 4.718c-5.708 13.44-7.384 27.312-5.298 41.586z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.48 28.4l-23.116-2.883-.313 2.457 23.116 2.884.314-2.458z",
    fill: "#F9D700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.352 34.807L66.02 30.9l-.156 1.23 31.332 3.907.156-1.229zm-.505 3.973l-31.332-3.907-.156 1.228L96.69 40.01l.157-1.229zm-.508 3.967l-31.332-3.908-.157 1.229 31.332 3.908.157-1.229zm-.505 3.973l-31.332-3.908-.157 1.229 31.332 3.908.157-1.229zm-.506 3.968l-31.332-3.907-.156 1.228 31.331 3.908.157-1.229zm-.505 3.969L63.49 50.749l-.156 1.229 31.331 3.908.157-1.229zm-.505 3.967l-31.332-3.907-.156 1.228 31.332 3.908.156-1.229z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.692 52.94l-35.39-14.034c1.95-14.08 7.98-26.76 15.761-38.906l35.39 14.035c-8.96 11.573-14.128 24.574-15.761 38.906z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.53 14.715L64.903 6.138l-.931 2.3 21.627 8.576.931-2.299z",
    fill: "#F9D700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.67 21.633L58.355 10.008l-.465 1.15 29.313 11.624.465-1.149zm-1.505 3.717L56.852 13.726l-.466 1.15L85.7 26.5l.466-1.15zm-1.502 3.716L55.351 17.442l-.466 1.15 29.313 11.624.465-1.15zm-1.507 3.713L53.844 21.154l-.466 1.15 29.313 11.624.465-1.15zM81.65 36.49L52.339 24.867l-.466 1.15L81.185 37.64l.466-1.15zm-1.5 3.712L50.835 28.577l-.465 1.15L79.683 41.35l.466-1.15zm-1.506 3.718L49.33 32.295l-.466 1.15 29.313 11.624.466-1.15z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.942 56.322H33.815c-3.484-13.787-2.656-27.775 0-41.914h38.127c-3.965 14.04-3.874 28.01 0 41.914z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.989 18.693h-23.3v2.476h23.3v-2.476z",
    fill: "#F9D700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.647 24.695h-31.58v1.238h31.58v-1.238zm0 4h-31.58v1.238h31.58v-1.238zm0 4.001h-31.58v1.238h31.58v-1.238zm0 4.003h-31.58v1.238h31.58v-1.238zm0 3.999h-31.58v1.238h31.58v-1.238zm0 3.998h-31.58v1.238h31.58v-1.238zm0 4.001h-31.58v1.238h31.58v-1.238z",
    fill: "#4285F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.244 47.954L33.109 37.85a1.491 1.491 0 00-.55-.545c-.227-.13-.486-.2-.75-.2h-7.09c-.397 0-.778.157-1.06.435-.28.279-.439.656-.439 1.05v61.909c0 1.276.513 2.5 1.425 3.402a4.888 4.888 0 003.439 1.41h72.774a4.904 4.904 0 003.439-1.41 4.795 4.795 0 001.425-3.402V52.327a4.35 4.35 0 00-1.295-3.092 4.446 4.446 0 00-3.126-1.281H46.244z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessFiles);
export default __webpack_public_path__ + "static/media/accessFiles.2e3d7a40a69f8d0b1c1bba764e6393f6.svg";
export { ForwardRef as ReactComponent };